import { CUSTOM_ELEMENTS_SCHEMA, Component, input, signal, viewChild } from '@angular/core';
import {
  SECOES_BENEFICIOS,
  SECOES_BENEFICIOS_DISPONIVEIS,
  SecaoBeneficios,
} from '../../../core/utils/parametros/beneficios.defaults';
import { BeneficiosAntecipacaoComponent } from './antecipacao/beneficios-antecipacao.component';
import { BeneficiosElegibilidadeComponent } from './elegibilidade/beneficios-elegibilidade.component';
import { BeneficiosOpcoesRendaComponent } from './opcoes-renda/beneficios-opcoes-renda.component';
import { BeneficiosRentabilidadeComponent } from './rentabilidade/beneficios-rentabilidade.component';
import { BeneficiosValorMinimoSaldoComponent } from './valor-minimo-saldo/beneficios-valor-minimo-saldo.component';
import { BeneficiosVisaoGeralComponent } from './visao-geral/beneficios-visao-geral.component';

/** Visão Geral ainda aparece "Em breve"; as demais seções estão habilitadas. */
@Component({
  selector: 'app-beneficios',
  standalone: true,
  imports: [
    BeneficiosVisaoGeralComponent,
    BeneficiosElegibilidadeComponent,
    BeneficiosOpcoesRendaComponent,
    BeneficiosAntecipacaoComponent,
    BeneficiosRentabilidadeComponent,
    BeneficiosValorMinimoSaldoComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './beneficios.component.html',
  styleUrl: './beneficios.component.scss',
})
export class BeneficiosComponent {
  readonly planoId = input.required<number>();
  readonly nomePlano = input('');

  private readonly elegibilidade = viewChild(BeneficiosElegibilidadeComponent);

  readonly secoes = SECOES_BENEFICIOS;
  readonly secaoAtiva = signal<SecaoBeneficios>('elegibilidade');
  /** Criada na primeira visita e mantida ao trocar de seção, para não perder alterações. */
  readonly elegibilidadeAberta = signal(true);
  readonly opcoesRendaAberta = signal(false);
  readonly antecipacaoAberta = signal(false);
  readonly rentabilidadeAberta = signal(false);
  readonly valorMinimoSaldoAberta = signal(false);
  /** Benefício a abrir quando a Elegibilidade for criada pelo "Editar regras" da Visão Geral. */
  readonly beneficioInicial = signal<number | null>(null);

  secaoDisponivel(secao: SecaoBeneficios): boolean {
    return SECOES_BENEFICIOS_DISPONIVEIS.has(secao);
  }

  selecionarSecao(secao: SecaoBeneficios): void {
    if (this.secaoDisponivel(secao)) {
      this.secaoAtiva.set(secao);
      if (secao === 'elegibilidade') {
        this.elegibilidadeAberta.set(true);
      } else if (secao === 'opcoes-renda') {
        this.opcoesRendaAberta.set(true);
      } else if (secao === 'antecipacao') {
        this.antecipacaoAberta.set(true);
      } else if (secao === 'rentabilidade') {
        this.rentabilidadeAberta.set(true);
      } else if (secao === 'valor-minimo-saldo') {
        this.valorMinimoSaldoAberta.set(true);
      }
    }
  }

  /** "Editar regras" da Visão Geral: abre a Elegibilidade já no benefício. */
  editarBeneficio(id: number): void {
    const aberta = this.elegibilidade();
    if (aberta) {
      aberta.selecionar(id);
    } else {
      this.beneficioInicial.set(id);
    }
    this.selecionarSecao('elegibilidade');
  }
}
